import { Link } from 'react-router-dom';
import { PartyPopper } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

export function ContractWonCelebration({
  open,
  onOpenChange,
  clientName,
  projectId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  clientName?: string | null;
  projectId?: string | null;
}) {
  const who = clientName?.trim() || 'this sale';
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="overflow-hidden border-amber-300 bg-[radial-gradient(circle_at_top,_rgba(251,191,36,0.28),_transparent_55%)] sm:max-w-md"
        data-testid="contract-won-celebration"
      >
        <DialogHeader className="items-center text-center">
          <div className="mb-2 flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 text-amber-700">
            <PartyPopper className="h-8 w-8" aria-hidden />
          </div>
          <DialogTitle className="font-newsreader text-3xl font-semibold tracking-tight">
            This sale is won!
          </DialogTitle>
          <DialogDescription className="text-base text-foreground">
            {who === 'this sale'
              ? 'The contract is won and the sales status is Sold. Take the moment.'
              : `${who} is sold. The contract is won — this is the moment.`}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          {projectId ? (
            <Button asChild>
              <Link to={`/projects/${projectId}`}>Open the project</Link>
            </Button>
          ) : null}
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Keep going
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
